import React, {ReactElement, useEffect} from "react";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogTitle,
    DialogTrigger
} from "../ui/dialog";
import PrettyYamlViewer from "./YamlViewer";
import {XIcon} from "lucide-react";
import {SingleSelectorSearchableDropdown} from "../Input/SingleSelectorSearchableDropdown";
import {DropDownItem} from "../Input/MultiSelectorDropdown/MultiSelectorDropDown";

function DeploymentYamlDialog(props: {
    yamls: Map<string, string>
    kind: string
    dialogTrigger: ReactElement
}) {
    const [currentEnvironment, setCurrentEnvironment] = React.useState<string>("")
    const [currentYaml, setCurrentYaml] = React.useState<string>("")
    const [dropdownItems, setDropdownItems] = React.useState<DropDownItem[]>([])
    const [selectedItem, setSelectedItem] = React.useState<DropDownItem>({displayName: "", value: ""})

    useEffect(() => {
        // Convert Map to array and sort alphabetically
        const sortedEnvironments = Array.from(props.yamls.keys()).sort((a, b) => a.localeCompare(b));
        
        // Create dropdown items
        const items = sortedEnvironments.map(env => ({
            displayName: env,
            value: env
        }));
        setDropdownItems(items);
        
        // Set initial values
        if (sortedEnvironments.length > 0) {
            const firstEnv = sortedEnvironments[0];
            setCurrentEnvironment(firstEnv);
            setCurrentYaml(props.yamls.get(firstEnv) || "");
            setSelectedItem({displayName: firstEnv, value: firstEnv});
        }
    }, [props.yamls]);

    return (
        <Dialog>
            <DialogTrigger asChild>
                {props.dialogTrigger}
            </DialogTrigger>
            <DialogContent className={"w-1/2 h-5/6"}>
                <div className={"flex flex-row justify-between items-center grow"}>
                    <div className={"flex justify-end items-center gap-x-2"}>
                        <DialogTitle className={"text-textmedium"}>{props.kind} Yaml</DialogTitle>
                        { props.yamls.size > 1 &&
                            <div className={"flex items-center text-textmedium font-semibold mr-2"}>
                                <SingleSelectorSearchableDropdown
                                    displaySettings={{
                                        smallSize: false,
                                        borderClassName: "border rounded",
                                        className: "h-full",
                                        dropdownSide: "bottom",
                                        dropdownAlign: "start"
                                    }}
                                    noMatchString="No matching clusters"
                                    possibleItems={dropdownItems}
                                    searchPlaceholder="Search clusters..."
                                    selected={selectedItem}
                                    setSelected={(item) => {
                                        setSelectedItem(item);
                                        setCurrentEnvironment(item.value);
                                        setCurrentYaml(props.yamls.get(item.value) || "");
                                    }}
                                    disableWildcard={true}
                                />
                            </div>
                        }
                    </div>
                    <div className={"flex flex-col justify-center"}>
                        <DialogClose asChild>
                            <XIcon className={"text-textdark hover:cursor-pointer hover:text-primary"}/>
                        </DialogClose>
                    </div>
                </div>
                <PrettyYamlViewer yamlString={currentYaml}/>
            </DialogContent>
        </Dialog>
    )
}

export default DeploymentYamlDialog